module.exports = __webpack_public_path__ + "static/img/ydybtnsf.5b16631.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ydybtnsf.jpg
// module id = 8E/v
// module chunks = 1